import { 
	createSlice,
	createAsyncThunk,
} from '@reduxjs/toolkit'
import {envAwarePost} from '../util/util'

export const addNewMaxMetric = createAsyncThunk(
	'addNewMaxMetric',
	async (payload,{getState,dispatch}) => {
		//get state
		const state = getState()
		//pull client_id from state by grabbing it off
		//the workout associated with the current %RM
		const workout_id = state.percentMaxCalculator.workout_id
		const client_id = state.allEvents.workouts.entities[workout_id]?.client_id
		const postData = {
			param4:payload.addToAllClients ? 'allClients' : 'single',
			param2:payload.description,
			item_db_name:payload.name,
			integration_id:1,
			operation:'add',
			client_id
		}
		if(payload.initialValue){
			postData.initialValue = payload.initialValue
			postData.initialDate = payload.initialDate
			postData.operation = 'addWithInitialValue'
		}
		return await envAwarePost('assessmentListAddEditDeleteMobWeb/',postData)
	}
)

export const getOneRepMaxes = createAsyncThunk(
	'getOneRepMaxes',
	async (_,{getState}) =>{
		//get state
		const state = getState()
		//pull client_id from state by grabbing it off
		//the workout associated with the current %RM
		const workout_id = state.percentMaxCalculator.workout_id
		const client_id = state.allEvents.workouts.entities[workout_id]?.client_id
		return await envAwarePost('api/fit-stats/api/',{
			action:'getOneRepMaxes',
			client_id
		})
	}
)

const slice = createSlice({
	name: 'percentMaxCalculator',
	initialState:{
		show:false,
		workout_id:null,
		exercise_id:null,
		set_id:null,
		integratedMetrics:[]
	},
	reducers: {
		setShow:(state,action)=>{ state.show = action.payload },
		setWorkout:(state,action)=>{ state.workout_id = action.payload },
		setExercise:(state,action)=>{ state.exercise_id = action.payload },
		setSetId:(state,action)=>{ state.set_id = action.payload },
	},
	extraReducers:{
		[getOneRepMaxes.fulfilled] : (state,action)=>{
			state.integratedMetrics = action.payload.data
		},
		[addNewMaxMetric.pending] : (state,action)=>{
			const {initialValue,name} = action.meta.arg
			if(initialValue){
				state.integratedMetrics.push({
					assessment_name:name,
					value:initialValue
				})
			}
		}
	}
})

export const {
	setShow,
	setSetId,
	setWorkout,
	setExercise,
} = slice.actions

export default slice.reducer